







































































import { Component, Prop, Mixins } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import { updateRegistration } from '@/utils/updateRegistration';

import { ConfigFormData } from '@/models/onboarding';
import { StartGuideTask } from '@/models/start-guide';

import { validation as formValidate } from '@/views/Onboarding/Steps/Refund/validation';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RefundConfigForm from '@/components/organisms/RefundConfigForm/RefundConfigForm.vue';
import { RewardsProgramFormState } from '@/models/rewards-program';
import { treatError } from '@/utils';
import { IBusinessType } from '@/models/business';
import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';
import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import LoyaltySetupBase from '@/views/Onboarding/Steps/LoyaltySetup/LoyaltySetupBase.vue';
import LoyaltyConfigForm from '@/components/organisms/LoyaltyConfigForm/LoyaltyConfigForm.vue';
import InfoIcon from '@/components/icons/Info.vue';
import { Typography } from '@/components/atoms';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';
import { getOauthState, isOauthSession } from '@/router/router-utils';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    RefundConfigForm,
    LoyaltyConfigForm,
    FilledButton,
    InfoIcon,
    Typography
  }
})
export default class RewardRatio extends Mixins(
  LoyaltySetupBase,
  BusinessOnboardingModel
) {
  @Prop() task!: StartGuideTask;

  signUpService = new SignUpService();
  businessService: BusinessService = new BusinessService();

  OnlineOnboardingURL = OnlineOnboardingURL;

  formDataRefund: any = {
    type: null,
    value: undefined,
    customValue: '',
    state: {},
    customValueFocused: false
  };

  formData: any = {
    type: null,
    value: undefined,
    customValue: '',
    state: {},
    customValueFocused: false
  };
  loadingSubmit = false;

  get isValidForm() {
    return formValidate(this.formDataRefund) && formValidate(this.formData);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get rewardsProgramFormData() {
    return this.$store.getters[
      'rewardsProgram/getFormData'
    ] as RewardsProgramFormState;
  }

  get tPrefixLoyalty() {
    return 'common.components.loyaltyExample';
  }

  get currencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  handleChangeRefundConfig(formData: ConfigFormData) {
    this.formDataRefund = formData;

    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      refundPolicy: formData
    });
  }

  handleChangeFormData(formData: ConfigFormData) {
    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      rewardRatio: formData
    });

    this.formData = formData;
  }

  async onSubmit() {
    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');

      return;
    }

    const { customValue, value } = this.formDataRefund;

    const payload: any = {
      refundsLimitDays: value || customValue,
      coinPurchaseRatio: this.coinPurchaseRatio,
      coinRewardPercentage: this.percentInCoins,
      operationType:
        this.rewardsProgramFormData.operationType || IBusinessType.ONLINE
    };

    this.loadingSubmit = true;

    try {
      const response = await this.signUpService.setupRules(payload);
      if (response && response.data) {
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.businessInfo,
          refundsLimitDays: response.data.refundsLimitDays,
          coinRewardPercentage: response.data.coinRewardPercentage,
          coinPurchaseRatio: response.data.coinPurchaseRatio,
          operationType: payload.operationType
        });
        this.$store.dispatch('business/SET_REWARD_STATUS', {
          ...this.$store.getters['business/getRewardStatus'],
          operationStatus: 'active'
        });

        await Promise.all([
          updateRegistration('manage-rewards'),
          updateRegistration('return-policy')
        ]);

        this.$router.push(OnlineOnboardingURL.BRANDED_COIN);
      }
    } catch (e) {
      treatError(e);
    } finally {
      this.loadingSubmit = false;
    }
  }

  async created() {
    if (!this.businessInfo && !isOauthSession()) {
      this.businessService.getBusinessInfo().then((res: any) => {
        if (res && res.data) {
          eventBus.$emit('setBusinessInfo', res.data);
          const data = res.data;
          data.manager = data.loggedInManager;
          this.$store.dispatch('business/SET_BUSINESS_INFO', {
            ...this.$store.getters['business/getBusinessState'],
            ...data
          });
        }
      });
    }
    if (!this.businessInfo && isOauthSession()) {
      try {
        this.$showLoaderWithLocker();
        const oauthState = getOauthState();

        await this.onCreateBusiness();

        this.onEditedImportedBusinessDate(oauthState);
      } finally {
        this.$hideLoader();
      }
    }
    segmentIo.track('NPO Sign Up | Online Setup Flow Started', {
      'Signup from Online Provider': true
    });
  }
}
